import * as React from 'react';
import { localization } from '../../shared/localization/localization';

import './icon-styles.css';

export const ConfirmSendIcon = () => {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
        >
            <path
                className="icon-fill"
                d="M27.29,17a.8.8,0,0,0-.44.31l-5.36,7.9L19,22.7a.57.57,0,0,0-.92,0l-.92.92a.58.58,0,0,0,0,.92L21,28.28a1.24,1.24,0,0,0,.79.42,1.07,1.07,0,0,0,.83-.51l6.51-9.56c.2-.1.08-.59-.23-.79l-1.11-.73A.59.59,0,0,0,27.29,17Z"
            />
            <path
                className="icon-fill"
                d="M6.86,2.8A4.08,4.08,0,0,0,2.79,6.86V25.14A4.08,4.08,0,0,0,6.86,29.2H19l-2-2H6.86a2,2,0,0,1-2-2V6.86a2,2,0,0,1,2-2h7.42c.71.2.7,1.12.7,2V9.91a1,1,0,0,0,1,1h3c1,0,2,0,2,1v10l.19.19,1.84-2.73V10.92c0-1.11-1-2.14-2.73-3.87-.31-.2-.52-.49-.83-.7s-.49-.52-.7-.82C17.13,3.8,16.1,2.8,15,2.8Z"
            />
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/App/shared/icons/pt-icon-confirm-send.tsx